// This variable will store the original location (parent element) of the desktop navigation menu.
// We'll use this to move the navigation menu back to its original spot when needed.
let originalNavLocation = null;

// This function moves the desktop navigation menu into the off-canvas menu on smaller screens (like phones and tablets).
export function moveDesktopNavToOffCanvas() {
    // First, find the desktop navigation menu and the off-canvas content area using their CSS classes.
    const desktopNav = document.querySelector('.elementor-nav-menu--main');
    const offCanvasContent = document.querySelector('.e-off-canvas__content');

    // If either the desktop navigation or the off-canvas content area can't be found, stop the function.
    if (!desktopNav || !offCanvasContent) {
        return;
    }

    // Check if the screen size is less than or equal to 1024 pixels (typical for tablets and phones).
    if (window.matchMedia('(max-width: 1024px)').matches) {
        // If we're on a smaller screen, move the navigation menu to the off-canvas content area.

        // Check if the navigation menu is already inside the off-canvas content area.
        if (desktopNav.parentNode !== offCanvasContent) {
            // If it's not, store the navigation menu's original location (parent element) if we haven't already.
            if (!originalNavLocation) {
                originalNavLocation = desktopNav.parentNode;
            }

            // Then, move the navigation menu into the off-canvas content area.
            offCanvasContent.appendChild(desktopNav);
        }
    } else {
        // If we're on a larger screen (desktop), move the navigation menu back to its original location.

        // Check if the navigation menu is NOT in its original location AND we have stored the original location.
        if (
            desktopNav.parentNode !== originalNavLocation &&
            originalNavLocation
        ) {
            // Move the navigation menu back to its original location.
            originalNavLocation.appendChild(desktopNav);

            // Clear the stored original location, as it's no longer needed.
            originalNavLocation = null;
        }
    }
}

export function initNavMobile() {
    moveDesktopNavToOffCanvas();
    window.addEventListener('resize', moveDesktopNavToOffCanvas);
}
